<template>
    <div id="app">
        <RouterView/>
        <div class="version d-print-none">v{{version}}</div>
    </div>
</template>

<script>

import { version } from '../package'

export default {
    name: 'app',
    data () {
        return {
            version
        }
    }
}
</script>

<style>
.version {
    color: #798d9f;
    text-align: center;
    margin-top: 25px;
    font-size: 15px;
}
</style>
